import React from 'react';
import * as R from 'ramda';
import classnames from 'classnames';
import { inject, observer } from 'mobx-react';
import { maxNumberByType } from 'components/ComponentNavigator/AllForBottom';

import './GalleryCheck.scss';

interface GalleryCheck {
  index: number;
}
export const GalleryCheck = inject('rootStore')(
  observer(function (props: GalleryCheck) {
    const type = R.path(
      ['rootStore', 'galleryStore', 'jigsaw', 'type'],
      props
    ) as string;
    const maximumOfCurrentType = maxNumberByType(type);
    const length = R.pathOr(
      0,
      ['rootStore', 'galleryStore', 'jigsaw', 'jigsawList', 'length'],
      props
    );
    const shouldDisabledShow = length >= maximumOfCurrentType;
    const checked = props.index !== -1;
    return (
      // 尝试去掉主题配色，直接使用微信绿，做突出显示 2023-05-30
      <div
        className={classnames({
          'gallery-check': true,
          [checked ? 'checked' : 'unchecked']: true,
          //  下面是后期加的，用于区分不同的类型
          [`checkbox-${type}`]: true,
          //  是否超过了最大数量
          [`checkbox-${type}-exceed`]: shouldDisabledShow,
        })}
        style={
          {
            /*backgroundColor, color: h1Color*/
          }
        }
      >
        {props.index === -1 ? '' : props.index + 1}
      </div>
    );
  })
);
